import UserAvatar from '../../ui-kit/components/atoms/UserAvatar'
import ReactionButton from '../atoms/buttons/ReactionButton'
import CommentButton from '../atoms/buttons/CommentButton'
import {getFormattedDate, getFullDate} from '../../helpers/dayjs'
import ReactionCounter from '../molecules/ReactionCounter'

const Comment = ({data, commentButtonClick, isAnswer}) => {
  return (
    <article className={`comment ${isAnswer && 'answer'}`}>
      <UserAvatar size="big" picture={data?.author.picture} />
      <div>
        <div className="globe">
          <header className="header-comment">
            <p className="name">
              {data?.author.firstname} {data?.author.lastname}
            </p>
            <time className="time" title={getFullDate(data?.created_at)}>
              {getFormattedDate(data?.created_at)}
            </time>
          </header>
          <p className="content-comment">{data?.comment}</p>
        </div>
        <footer className="footer-comment">
          <div className="buttons">
            <ReactionButton tiny />
            {!isAnswer && (
              <CommentButton
                onClick={commentButtonClick}
                tiny
                text={
                  data?.stats.answers > 0
                    ? `Responder (${data?.stats.answers})`
                    : 'Responder'
                }
              />
            )}
          </div>
          <ReactionCounter
            counter={data?.stats.reactions}
            reactions={data?.last_reactions}
          />
        </footer>
      </div>
    </article>
  )
}

export default Comment
